import React from 'react';
import { Card, Table } from 'antd';
import CityTableColumns from './CityTableColumns';

/**
 * Component to display city data in a table format
 * @param {Object} props - Component props
 * @param {Array} props.filteredLocations - Array of location data to display
 * @returns {JSX.Element} Table view of city data
 */
const CityTableView = ({ filteredLocations }) => {
  const cityColumns = CityTableColumns();
  
  return (
    <Card title={`City Data (${filteredLocations.length} cities)`}>
      <Table 
        dataSource={filteredLocations} 
        columns={cityColumns}
        rowKey={(record) => `${record.city}-${record.state}`}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 'max-content' }}
      />
    </Card>
  );
};

export default CityTableView;
